// react
import { useDispatch } from 'react-redux';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

// material ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

// api
import { useDeleteEnergyGroupInitiativeMutation } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// components
import { showSnackbar } from '@/redux/snackbarSlice';

const DeleteInitiativeDialog = ({ open, onClose, energyGroup, initiative }) => {
  const { t } = useTranslation('energyxplorer-initiatives-tab');
  const dispatch = useDispatch();
  const [deleteEnergyInitiative] = useDeleteEnergyGroupInitiativeMutation();

  const handleDeleteInitiative = async () => {
    if (!energyGroup || !initiative) return;
    const result = await deleteEnergyInitiative({
      groupId: energyGroup.energyGroupId,
      initiativeId: initiative.id,
    });

    if (!('error' in result)) {
      dispatch(
        showSnackbar({ message: 'Initiativ fjernet', severity: 'success' }),
      );
      onClose();
    }
    // Errors are handled globally by apiErrorMiddleware (snackbar + App Insights).
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('dialogs.delete.title')}</DialogTitle>
      <DialogContent dividers>
        <Typography>{t('dialogs.delete.message')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="text">
          {t('dialogs.delete.actions.cancel')}
        </Button>
        <Button
          onClick={handleDeleteInitiative}
          startIcon={<DeleteRoundedIcon />}
          variant="contained"
          color="error"
        >
          {t('dialogs.delete.actions.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteInitiativeDialog;
